import moment from 'moment';
import {DATE_FORMAT} from "@/shared/enums/DateFormats";
import {DOCUMENT_FILE_STATUS} from "@/shared/enums/DocumentFile";
import {DOCUMENT_GROUP_TYPES} from "@/shared/enums/DocumentGroup";

var reportSelectorMixin = {
    data: function () {
        return {
            entitySelectedId: '',
            reportsSelected: [],
            groupType: {},
            client: {},
            employee: {},
            reportGroups: {},
            reportsToSelect: [],
            loading: false,
            items: [],
            path_id: this.id,
            path_type: this.type,
            dialog: false,
            selectedItem: {},
        }
    },
    computed:{
        moment(){
            return moment;
        },
        DATE_FORMAT(){
            return DATE_FORMAT;
        },
        DOCUMENT_FILE_STATUS(){
            return DOCUMENT_FILE_STATUS;
        }
    },
    watch:{
        id(value){
            this.path_id = value;
        },
        type(value){
            this.path_type = value;
        }
    },
    methods: {
        async getEntityGroupType(id)
        {
            await this.$store.dispatch('getGroupType',{id: id});
            this.groupType = this.$store.getters['getGroupType'];
            this.getReportsGroupsAndRules();
        },
        async getReportsGroupsAndRules()
        {
            if(!this.groupType.hasOwnProperty('reportGroups') || !this.groupType.reportGroups.length)
                return;

            for(let group in this.groupType.reportGroups)
            {
                let reportGroupId = this.groupType.reportGroups[group].id;
                await this.$store.dispatch('getDocumentGroup',{id: reportGroupId});
                let reportGroup = this.$store.getters['getDocumentGroup'];
                this.reportGroups[reportGroupId] = reportGroup;

                for(let reportRule in reportGroup.documentRules)
                {
                    this.reportsToSelect.push(reportGroup.documentRules[reportRule]);
                }
            }
        },
        expandedEvent(event){
            this.$log.debug('table inner expanded event : ', event);
            if(event.value) {
                this.selectedItem = event.item;
                if (this.$refs.innerTable != undefined)
                    this.$refs.innerTable.refresh(event.item.id);
            }
        }
    }
}

export {
    reportSelectorMixin,
}